export default __webpack_public_path__ + "static/media/25101302.6533db1a.jpg";